import GenericErrorImage from '@/assets/images/errors/generic.png';
import settings from '@/constants/constants';
import { Box, Link, Stack, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

const ImageContainer = styled(Box)(({ theme }) => ({
  '& img': {
    width: '343px',
    [theme.breakpoints.up('sm')]: {
      width: '421px',
    },
  },
}));

function ExpiredLink() {
  return (
    <Stack gap={6} textAlign="center">
      <ImageContainer>
        <img src={GenericErrorImage} alt="" />
      </ImageContainer>
      <Typography variant="subtitle1">Looks like your application has already been submitted</Typography>

      <Typography variant="body1">
        If you have any questions email us at{' '}
        <b>
          <Link to={`mailto:${settings.support.email}`}>{settings.support.email}</Link>
        </b>{' '}
        <br />
        and we&apos;ll get it sorted for you.
      </Typography>
    </Stack>
  );
}

export default ExpiredLink;
